import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@mui/material'
import { useState, useCallback, useRef, useEffect } from 'react'
import { getStatus } from '../../Services/Api/ApiService'
import { useMsal } from '@azure/msal-react'
import { LoadingSpinner, useLoadingSpinner } from '../../Components/LoadingSpinner';
import { useAppDispatch } from '../../Services/Store';
import { setStatus } from '../../Services/Store/Slices/StatusSlice';

export interface GetWikiStatusDialogParameters {
  isOpen: boolean,
  onClose: () => void
}

export interface StatusData {
  time: string;
  status: string;
  annotation: string;
}

export const GetWikiStatusDialog: React.FC<GetWikiStatusDialogParameters> = (parameters) => {
  const { isLoading, startLoading, stopLoading } = useLoadingSpinner();
  const msalContextRef = useRef(useMsal());
  const [statusData, setStatusData] = useState<StatusData | null>(null);
  const dispatch = useAppDispatch();

  const handleUpdate = useCallback((): void => {
    dispatch(setStatus);
    startLoading();

    msalContextRef.current.instance.setActiveAccount(msalContextRef.current.accounts[0]);

    console.log(msalContextRef.current.accounts?.[0]?.idTokenClaims?.roles);
    msalContextRef.current.accounts?.[0]?.idTokenClaims?.roles?.map(r => console.log(r));

    getStatus(msalContextRef.current)
      .then((data: any) => {
        setStatusData(data);
      })
      .finally(() => {
        stopLoading();
      });
  }, [dispatch, startLoading, stopLoading]);

  useEffect(() => {
    if (parameters.isOpen) {
      handleUpdate();
    }
  }, [parameters.isOpen, handleUpdate]);

  const handleClose = () => {
    setStatusData(null);
    parameters.onClose();
  };

  return (
    <Dialog open={parameters.isOpen}>
      <DialogTitle style={{ paddingBottom: 0 }}>Status ostatnio wykonanej aktualizacji</DialogTitle>

      <DialogContent dividers style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <Button variant="contained" onClick={handleUpdate} style={{ marginBottom: 16 }}>ODSWIEŻ STAN</Button>
        </div>
        {isLoading && <LoadingSpinner />}
        {statusData && (
          <div style={{ textAlign: 'left' }}>
            <p>Czas: {statusData.time}</p>
            <p>Status: {statusData.status}</p>
            <p>Adnotacja: {statusData.annotation}</p>
          </div>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Zamknij</Button>
      </DialogActions>
    </Dialog>
  );
};